import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const LOGO_SRC = '/images/logo.svg';

export default function AppHeader() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const displayName = user?.name || user?.email || 'User';
  const initial = displayName.charAt(0).toUpperCase();

  const handleLogout = async () => {
    await logout();
    navigate('/login', { replace: true });
  };

  return (
    <header className="app-header">
      <div className="d-flex align-items-center">
        <img src={LOGO_SRC} alt="FormFit Admin" className="app-header__logo" />
      </div>
      <div className="user-dropdown dropdown">
        <button
          type="button"
          className="dropdown-toggle"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          <span className="user-avatar">{initial}</span>
          <span className="d-none d-md-inline">{displayName}</span>
          <i className="bi bi-chevron-down small" />
        </button>
        <ul className="dropdown-menu dropdown-menu-end shadow">
          <li><span className="dropdown-item-text small text-muted">{user?.email}</span></li>
          <li><hr className="dropdown-divider" /></li>
          <li>
            <button type="button" className="dropdown-item" onClick={handleLogout}>
              <i className="bi bi-box-arrow-right me-2" />
              Logout
            </button>
          </li>
        </ul>
      </div>
    </header>
  );
}
